const Barba = require( 'barba.js' )
const detectIt = require('detect-it')
const { default: { hasTouch } } = detectIt

class Marker {
  constructor(id, icone, name, details, position, url, container, domContainer, stageWidth) {

    this.id = id
    this.icone = icone
    this.name = name
    this.details = details
    this.position = position
    this.url = url
    this.container = container
    this.padding = 20
    if(stageWidth < 768) {
      this.width = 70
      this.fontSize = 65
    } else if(stageWidth < 1280) {
      this.width = 60
      this.fontSize = 55
    } else {
      this.width = 52
      this.fontSize = 48
    }

    // Create marker
    this.sprite = new PIXI.Graphics()
      .beginFill(0x000000, 0.25)
      .lineStyle(1, 0xffffff)
      .drawRect(0, 0, this.width, this.width)
      .endFill()
    this.sprite.pivot.set(this.sprite.width/2, this.sprite.height/2)
    this.sprite.buttonMode = true
    this.sprite.interactive = true
    this.sprite.x = (this.position.x * this.container.rootWidth) / 100
    this.sprite.y = (this.position.y * this.container.rootHeight) / 100

    // Create icon
    this.icone = PIXI.Sprite.fromImage(this.icone)
    this.icone.width = this.width / 1.8
    this.icone.height = this.width / 1.8
    this.icone.x = (this.width - this.icone.width) / 2
    this.icone.y = (this.width - this.icone.width) / 2
    this.sprite.addChild(this.icone)
    
    // Create label
    this.label = new PIXI.Container()

    // Create label text
    this.labelText = new PIXI.Text(this.name, {
      fontFamily: 'Ubuntu',
      fontSize: this.fontSize,
      letterSpacing: 1,
      fontWeight: 600,
      fill:'#fff'
    });
    this.labelText.scale.x = 0.5
    this.labelText.scale.y = 0.5
    this.labelText.x = -this.labelText.width - this.padding
    this.labelText.y = -this.labelText.height - this.padding

    // Create label background
    this.background = new PIXI.Graphics()
      .beginFill(0x000000)
      .drawRect(
        -this.labelText.width - this.padding * 2, 
        -this.labelText.height - this.padding * 2,
        this.labelText.width + this.padding * 2,
        this.labelText.height + this.padding * 2
      )
      .endFill()
    this.background.alpha = 0.7

    this.label.addChild(this.background)
    this.label.addChild(this.labelText)

    // Label position
    if((this.sprite.x) < this.container.width/2){ // Left
      this.label.x = this.width + this.label.width
      if(this.position.y < this.sprite.height/2){ // Top
        this.label.y = this.width + this.label.height
      }
    }else{
      if(this.position.y < this.sprite.height/2){ // Top
        this.label.y = this.width + this.label.height
      }
    }
    this.sprite.addChild(this.label)
    this.sprite.alpha = 0

    if(!hasTouch) {
      this.sprite.on('mousedown', ({ data: { global } }) => {
        if(Barba.Pjax.getCurrentUrl() !== this.url){
          Barba.Pjax.goTo(this.url)
          domContainer.dispatchEvent(new CustomEvent('markerGo'))
        }else{
          domContainer.dispatchEvent(new CustomEvent('removeExpand'))
        }
      })
    }else{
      this.sprite.on('pointertap', ({ data: { global } }) => {
        if(Barba.Pjax.getCurrentUrl() !== this.url){
          Barba.Pjax.goTo(this.url)
          domContainer.dispatchEvent(new CustomEvent('markerGo'))
        }else{
          domContainer.dispatchEvent(new CustomEvent('removeExpand'))
        }
      })
    }
    
  }
}
module.exports = Marker